/**
 * Waseem Collection - Client-side Wishlist and UI Enhancement script
 */
(function() {
  'use strict';

  const WISHLIST_KEY = 'waseem_wishlist_items';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {
      console.error('Wishlist save error', e);
    }
  }

  function updateWishlistUI() {
    const list = getWishlist();
    document.querySelectorAll('.waseem-wishlist-btn').forEach(btn => {
      const id = btn.getAttribute('data-product-id');
      const isSaved = list.includes(id);
      const svg = btn.querySelector('svg');
      if (svg) {
        if (isSaved) {
          svg.setAttribute('fill', '#D32F2F');
          svg.setAttribute('stroke', '#D32F2F');
          btn.classList.add('is-active');
        } else {
          svg.setAttribute('fill', 'none');
          svg.setAttribute('stroke', 'currentColor');
          btn.classList.remove('is-active');
        }
      }
    });

    const badge = document.querySelector('.waseem-wishlist-count');
    if (badge) {
      badge.textContent = list.length;
      badge.style.display = list.length > 0 ? 'inline-flex' : 'none';
    }
  }

  function toggleWishlist(productId) {
    let list = getWishlist();
    if (list.includes(productId)) {
      list = list.filter(item => item !== productId);
    } else {
      list.push(productId);
    }
    saveWishlist(list);
    updateWishlistUI();
  }

  document.addEventListener('DOMContentLoaded', function() {
    updateWishlistUI();

    document.addEventListener('click', function(e) {
      const btn = e.target.closest('.waseem-wishlist-btn');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        const id = btn.getAttribute('data-product-id');
        if (id) {
          toggleWishlist(id);
        }
      }
    });
  });
})();
